import {
    useSyncExternalStore,
    useImperativeHandle,
    type ReactNode,
    forwardRef
} from "react";
import {
    StyleSheet,
    View
} from "react-native";
import {
    PortalKeyContext,
    context
} from "./context";
import {
    webStyle
} from "../../utils";

export interface IManagerHandles {
    update(key?: string, children?: ReactNode, name?: string): void;
    mount(key: string, children: ReactNode, name?: string): void;
    unmount(key?: string): void;
}

export const Manager = forwardRef(({
    name
}: {
    name?: string;
}, ref): Array<ReactNode> => {
    const portals = useSyncExternalStore(context.subscribe, context.getPortals, context.getServerPortals);

    useImperativeHandle(
        ref,
        (): IManagerHandles => ({
            unmount: context.unmount,
            update: context.update,
            mount: context.mount
        }),
    );

    return portals
        .filter(item => {
            if (item.name) {
                return item.name === name;
            }

            return !name;
        })
        .map((
            {
                children,
                isModal,
                key
            }
        ) => <PortalKeyContext.Provider
            key={`NCoreUIKit-Portal-${key}`}
            value={key}
        >
            <View
                accessibilityViewIsModal={isModal}
                style={[
                    StyleSheet.absoluteFill,
                    stylesheet.layer
                ]}
                collapsable={false}
            >
                {children}
            </View>
        </PortalKeyContext.Provider>);
});

const stylesheet = StyleSheet.create({
    layer: {
        pointerEvents: "box-none",
        ...webStyle({
            position: "fixed"
        })
    }
});
